// Word-by-word matching for a search box: every word typed must appear
// somewhere in the text, in any order. "smith 189" finds "Lot 189 · Smith",
// which a single substring match cannot. Case-, accent- and punctuation-
// insensitive, so "o'neil" finds "ONeil" and "12-a" finds "12A".
//
// Street words also match their abbreviations both ways ("oak ln" finds
// "Oak Lane", "oak lane" finds "Oak Ln"). That comparison is on WHOLE words
// only: "north" finds the word "N", never every text containing the letter n.
const norm = (s) => String(s == null ? '' : s)
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/['’.-]/g, '');

const tokens = (s) => norm(s).split(/[^a-z0-9#&@]+/).filter(Boolean);

// canonical abbreviation -> every spelling that means it (USPS suffixes plus
// the unit and direction words lot addresses use).
const STREET_WORDS = {
  ave: ['avenue', 'av', 'aven'],
  blvd: ['boulevard', 'blv'],
  cir: ['circle', 'circ'],
  ct: ['court', 'crt'],
  cv: ['cove'],
  dr: ['drive', 'drv'],
  hwy: ['highway', 'hiway'],
  ln: ['lane'],
  loop: ['lp'],
  pkwy: ['parkway', 'pky'],
  pl: ['place'],
  pt: ['point'],
  rd: ['road'],
  rdg: ['ridge'],
  sq: ['square'],
  st: ['street', 'str'],
  ter: ['terrace', 'terr'],
  trl: ['trail', 'tr'],
  way: ['wy'],
  xing: ['crossing'],
  bnd: ['bend'],
  crk: ['creek'],
  hl: ['hill'],
  holw: ['hollow'],
  lk: ['lake'],
  mdw: ['meadow', 'mdws', 'meadows'],
  vw: ['view'],
  n: ['north'], s: ['south'], e: ['east'], w: ['west'],
  ne: ['northeast'], nw: ['northwest'], se: ['southeast'], sw: ['southwest'],
  apt: ['apartment'], ste: ['suite'], bldg: ['building'], ph: ['phase'],
  blk: ['block'], lt: ['lot'],
};

const CANON = new Map();
Object.entries(STREET_WORDS).forEach(([abbr, words]) => {
  CANON.set(abbr, abbr);
  words.forEach(w => CANON.set(w, abbr));
});

export const canonicalWord = (w) => CANON.get(w) || null;

export const queryWords = (q) => tokens(q);

export const matchesAllWords = (text, q) => {
  const words = queryWords(q);
  if (!words.length) return true;
  const hay = norm(text);
  const canon = new Set(tokens(text).map(canonicalWord).filter(Boolean));
  return words.every(w => {
    if (hay.includes(w)) return true;
    const c = canonicalWord(w);
    return !!c && canon.has(c);
  });
};
